<template>
  <v-card class="card">
    <section :id="pageTopId" class="sample-image">
      <img
        :src="
          require('../../assets/images/combook_binding/binding_sample/image01.png')
        "
        alt="表紙"
      />
      <p class="sample-image-caption">表紙</p>
    </section>
    <section class="sample-image">
      <img
        :src="
          require('../../assets/images/combook_binding/binding_sample/image02.png')
        "
        alt="園・家庭ともに連絡欄に記入がある場合"
      />
      <p class="sample-image-caption">園・家庭ともに連絡欄に記入がある場合</p>
    </section>
    <section class="sample-image">
      <img
        :src="
          require('../../assets/images/combook_binding/binding_sample/image03.png')
        "
        alt="園・家庭ともに連絡欄に記入がある場合"
      />
      <p class="sample-image-caption">園・家庭ともに連絡欄に記入がある場合</p>
    </section>
    <section class="sample-image">
      <img
        :src="
          require('../../assets/images/combook_binding/binding_sample/image04.png')
        "
        alt="園・家庭ともに連絡欄に記入がある・写真がない場合"
      />
      <p class="sample-image-caption">
        園・家庭ともに連絡欄に記入がある・写真がない場合
      </p>
    </section>
    <section class="sample-image">
      <img
        :src="
          require('../../assets/images/combook_binding/binding_sample/image05.png')
        "
        alt="園のみ連絡欄に記入がある場合"
      />
      <p class="sample-image-caption">園のみ連絡欄に記入がある場合</p>
    </section>
    <section class="sample-image">
      <img
        :src="
          require('../../assets/images/combook_binding/binding_sample/image06.png')
        "
        alt="休園日の場合"
      />
      <p class="sample-image-caption">休園日の場合</p>
    </section>
    <section class="sample-image">
      <img
        :src="
          require('../../assets/images/combook_binding/binding_sample/image07.png')
        "
        alt="休園日の場合"
      />
      <p class="sample-image-caption">休園日の場合</p>
    </section>
    <section class="sample-image">
      <img
        :src="
          require('../../assets/images/combook_binding/binding_sample/image08.png')
        "
        alt="欠席の場合"
      />
      <p class="sample-image-caption">欠席の場合</p>
    </section>
    <section class="text-xs-center">
      <img
        :src="
          require('../../assets/images/combook_binding/binding_sample/three_dots.svg')
        "
        alt="..."
      />
    </section>
    <section class="sample-image">
      <img
        :src="
          require('../../assets/images/combook_binding/binding_sample/image09.png')
        "
        alt="メモページ"
      />
      <p class="sample-image-caption">メモページ</p>
    </section>
    <section class="sample-image">
      <img
        :src="
          require('../../assets/images/combook_binding/binding_sample/image10.png')
        "
        alt="メモページ"
      />
      <p class="sample-image-caption">メモページ</p>
    </section>
    <section class="sample-image">
      <img
        :src="
          require('../../assets/images/combook_binding/binding_sample/image11.png')
        "
        alt="裏表紙"
      />
      <p class="sample-image-caption">裏表紙</p>
    </section>
  </v-card>
</template>

<script>
export default {
  props: {
    pageTopId: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.card {
  padding-top: 56px !important; /* toolbarの高さを考慮して、パディングを追加 */
  background-color: #ffffff;
}
.card section {
  max-width: 443px;
  padding: 8px 16px;
  margin: 0 auto;
}

.card section.sample-image img {
  width: 100%;
  height: auto;
}

.card section.sample-image p.sample-image-caption {
  text-align: center;
}
</style>
